// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ProductConfigurableAttributes from "Src/component/ProductConfigurableAttributes";
import CategoryFilterOverlay from "Src/component/CategoryFilterOverlay";
import './ColoredDiamondFilter.style';
import FilterLabel from 'Component/FilterLabel';
import DimaondShapeFilter from 'Component/DimaondShapeFilter';
import DiamondCarat from 'Component/DiamondFilter/DiamondCarat.component';
import DiamondPrice from 'Component/DiamondFilter/DiamondPrice.component';
import ColorDiamondColorFilter from 'Component/ColorDiamondColorFilter';
import DiamondIntensityFilter from 'Component/DiamondIntensityFilter';
import DiamondOrigin from './DiamondOrigin.component';
import history from "@scandipwa/scandipwa/src/util/History";
import { generateQuery, getQueryParam, removeQueryParamWithoutHistory } from "@scandipwa/scandipwa/src/util/Url";
import { colordiamond_labcolor, colordiamond_naturalcolor } from 'Src/Value/ColorDiamond_color';

export class ColoredDiamondFilter extends PureComponent {
    static propTypes = {
        renderGetDiamond: this.propTypes,
        device: this.propTypes
    };

    state = {
        selectedOrigin: "",
        showFilterOptions: false
    }

    componentDidMount() {
        const location = window?.location;

        const originfilter = getQueryParam("diamond_created_from", location || '');

        if (originfilter) {
            this.setState({
                selectedOrigin: originfilter
            });
        } else {
            this.setState({
                selectedOrigin: "11"
            });

            const query = generateQuery({ diamond_created_from: `11` }, window?.location, history);
            history.push(query);
        }
    }

    renderGetDiamond = () => {
        const { renderGetDiamond } = this.props;

        renderGetDiamond();
    }

    selectOrigin = (value) => {
        const { selectedOrigin } = this.state;
        const location = window?.location;

        this.setState({
            selectedOrigin: value
        });

        if (!(selectedOrigin === value)) {
            const colorFilter = getQueryParam("fancy_color_dominant_color", location || '');

            if (value === "12") {
                const isColorAvailable = colordiamond_labcolor.some(item => item.code === colorFilter);

                if (!isColorAvailable) {
                    removeQueryParamWithoutHistory('fancy_color_dominant_color', history, window.location);
                }
            } else {
                const isColorAvailable = colordiamond_naturalcolor.some(item => item.code === colorFilter);

                if (!isColorAvailable) {
                    removeQueryParamWithoutHistory('fancy_color_dominant_color', history, window.location);
                }
            }

            const query = generateQuery({ diamond_created_from: `${value}` }, location, history);
            history.push(query);

            this.renderGetDiamond();
        }
    }

    renderShapeFilter = () => {
        return (
            <FilterLabel label={"Shape"}>
                <DimaondShapeFilter renderGetDiamond={this.renderGetDiamond} />
            </FilterLabel>
        )
    }

    renderCaratFilter = () => {
        return (
            <DiamondCarat renderGetDiamond={this.renderGetDiamond} />
        )
    }

    renderPriceFilter = () => {
        return (
            <DiamondPrice renderGetDiamond={this.renderGetDiamond} />
        )
    }

    renderColorFilter = () => {
        const { selectedOrigin } = this.state;

        return (
            <ColorDiamondColorFilter selectedOrigin={selectedOrigin} renderGetDiamond={this.renderGetDiamond} />
        )
    }

    renderIntensityFilter = () => {
        return (
            <DiamondIntensityFilter renderGetDiamond={this.renderGetDiamond} />
        )
    }

    renderOriginFilter = () => {
        const { selectedOrigin } = this.state;

        return (
            <DiamondOrigin selectOrigin={this.selectOrigin} selectedOrigin={selectedOrigin} />
        )
    }

    renderOtherFilters = () => {
        return (
            <>
                {this.renderCaratFilter()}
                {this.renderPriceFilter()}
                {this.renderColorFilter()}
                {this.renderIntensityFilter()}
            </>
        )
    }

    renderFilterSection = () => {
        const { device: { isMobile } } = this.props;

        if (isMobile) {
            return (
                <>
                    {this.renderShapeFilter()}
                    {this.renderOriginFilter()}
                </>
            )
        }

        return (
            <>
                {this.renderShapeFilter()}
                {this.renderOtherFilters()}
                {this.renderOriginFilter()}
            </>
        )
    }

    renderFilterOberlay = () => {
        const { device: { isMobile } } = this.props;
        const { showFilterOptions } = this.state;

        if (!isMobile) {
            return null;
        }

        const mainItems = document.getElementsByClassName('Router-MainItems');

        if (showFilterOptions) {
            if (mainItems?.length > 0) {
                mainItems[0].style.zIndex = "unset";
            }

            document.documentElement.style.overflow = 'hidden';
        } else {
            if (mainItems?.length > 0) {
                mainItems[0].style.zIndex = "99";
            }

            document.documentElement.style.overflow = 'unset';
        }

        return (
            <>
                <div className={(showFilterOptions ? "Overlay_isVisible CategoryFilterOverlay_isVisible " : "") + 'Overlay CategoryFilterOverlay'}>
                    <div className='CategoryFilterOverlay-Wrapper'>
                        <div className="filters-header--section">
                            <span></span>
                            <span>filters</span>
                            <span onClick={() => this.setState({ showFilterOptions: false })}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="CloseIcon"><path d="M16.192 6.34399L11.949 10.586L7.707 6.34399L6.293 7.75799L10.535 12L6.293 16.242L7.707 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"></path></svg>
                            </span>
                        </div>
                        <div className='DiamonFilter-Overlay_scroll'>
                            <div className='ProductConfigurableAttributes CategoryFilterOverlay-Attributes'>
                                {this.renderOtherFilters()}
                            </div>
                        </div>
                    </div>
                    <div className="CategoryFilterOverlay-SeeResults" >
                        <button className="CategoryFilterOverlay-Button Button" onClick={() => this.setState({ showFilterOptions: false })}>SEE RESULTS</button>
                    </div>
                </div>

                {!showFilterOptions && <div className='CategoryPage-Miscellaneous'>
                    <div className="CategoryPage-MiscellaneousLayoutWrapper">
                        <div className="CategoryPage-LayoutWrapper">
                            <button className="CategoryPage-Filter" onClick={() => this.setState({ showFilterOptions: true })}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="FilterIcon"><path d="M10 3H22V5H10V3Z"></path><path d="M10 19H22V21H10V19Z"></path><path d="M2 3H6V5H2V3Z"></path><path d="M2 19H6V21H2V19Z"></path><path d="M8 0H10V8H8V0Z"></path><path d="M8 16H10V24H8V16Z"></path><path d="M14 8H16V16H14V8Z"></path><path d="M14 11H2V13H14V11Z"></path><path d="M22 11H18V13H22V11Z"></path></svg>
                                <span>Filters</span>
                            </button>
                        </div>
                    </div>
                </div>}
            </>
        )
    }

    render() {
        return (
            <div className="ColoredDiamondFilter">
                <div className='ColoredDiamondFilter-Attributes'>
                    {this.renderFilterSection()}
                </div>

                {this.renderFilterOberlay()}
            </div>
        );
    }
}

export default ColoredDiamondFilter;
